import stationsRaw from "../data/carSharingStations.json";

const stations = stationsRaw.features.map((f: any) => {
    return {
        name: f.properties.Name,
        status: f.properties.Status,
        lat: f.geometry.coordinates[1],
        lng: f.geometry.coordinates[0],
    } 
});

import findNearest from "./findNearest";

export default async function findNearestCarSharing(start: any) {
    return {
        "existing": findNearest(start, stations.filter((station: any) => station.status === "in Betrieb")),
        "planned": findNearest(start, stations.filter((station: any) => station.status === "vorgesehen")),
    };
}



// WEBPACK FOOTER //
// ./src/lib/findNearestCarSharing.ts